import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/LabelImportant';
import create from './create';
import edit from './edit';
import list from './list';

const brands: ResourceProps = {
  name: 'brands',
  icon,
  options: { label: 'Marcas' },
  create,
  edit,
  list
};

export default brands;
